import React, { useContext } from 'react';
import { Form, Input, Divider } from 'antd';
import { ApplicationUIContext } from '@yuhuinc/ui-library';
import People from './People';
import PropertyAndUnit from './PropertyAndUnit';
import LeaseDates from '../../additional_information/LeaseDates';
import RentDeposits from '../../additional_information/RentDeposits';
import RentalIncentives from '../../additional_information/RentalIncentives';
import RentableItems from '../../additional_information/RentableItems';
import ServicesAndUtilities from './ServicesAndUtilities';
import AdditionalInformation from './AdditionalInformation';
import LeaseDocuments from './LeaseDocuments';

const LeaseDetailsForm = ({ form, formInitialValues, editable }) => {
  const { isMobile } = useContext(ApplicationUIContext);
  const selectedUnit = Form.useWatch('selectedUnit', form);

  return (
    <Form
      form={form}
      layout="vertical"
      size={isMobile && 'large'}
      initialValues={formInitialValues}
      scrollToFirstError
    >
      <Form.Item name="selectedUnit" hidden>
        <Input />
      </Form.Item>
      <People disabled={!editable} />
      <Divider />
      <PropertyAndUnit disabled={!editable} />
      {selectedUnit && (
        <>
          <Divider />
          <LeaseDates selectedUnit={selectedUnit} disabled={!editable} />
          <Divider />
          <RentDeposits selectedUnit={selectedUnit} disabled={!editable} />
          <Divider />
          <RentalIncentives selectedUnit={selectedUnit} disabled={!editable} />
          <Divider />
          <RentableItems selectedUnit={selectedUnit} disabled={!editable} />
          <Divider />
          <ServicesAndUtilities disabled={!editable} />
          <Divider />
          <AdditionalInformation />
          <Divider />
          <LeaseDocuments />
        </>
      )}
    </Form>
  );
};

export default LeaseDetailsForm;
